import { FaLinkedin, FaGithub, FaTwitter } from 'react-icons/fa'
import '../styles/Socials.css'
function Socials({location}) {
    return (
        <div className={`socials ${location}`}>
            <h1> <span className='fullname'>Kojo Antwi Osei-Sarfo</span> <span className='initials'>KAOS</span></h1>
                <ul>
                    <li><a href='https://github.com/Astrokojo'><FaGithub/></a></li>
                    <li><a href='https://www.linkedin.com/in/kaosei-sarfo/'><FaLinkedin/></a></li>
                    <li><a href='/'><FaTwitter/></a></li>
                </ul>
        </div>

    );
}
export default Socials